export default "/images/rx.svg?a27bd674245d02d42770b63e23bbee85";